import moment from "moment";

import { DATE_FORMAT } from "../constants/dateConstants";

export const getCurrentDate = (sep, date = new Date()) =>
  date.getDate() + sep + (date.getMonth() + 1) + sep + date.getFullYear();

export const getCurrentTime = () => new Date().toLocaleTimeString();

/**
 * Today as "YYYY-MM-DD" — the format a date input's `value`, `min` and `max` use.
 *
 * Local time, deliberately. `new Date().toISOString().slice(0, 10)` is the obvious
 * one-liner and is wrong: it is UTC, so for anyone east of UTC it returns yesterday for
 * part of the day. Used as a `min` that would leave today unselectable while the form
 * still demands a date. (widgetExport.js has that bug in a private `stamp()` helper,
 * where it only mis-dates a filename.)
 */
export const todayISO = () => moment().format(DATE_FORMAT);
